import { ReactElement } from 'react';

import { BackrsIcons, BackrsIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

const PROFICIENCY_STRINGS = appStrings.modules.competency.proficiency;

type ProficiencyLevelIconProps = Readonly<{
  iconName: BackrsIcons;
  text: string;
}>;

const IconItem = ({ iconName, text }: ProficiencyLevelIconProps) => (
  <Box sx={iconContainerStyles}>
    <BackrsIcon name={iconName} alt={text} />
    {text}
  </Box>
);

const iconContainerStyles: SxProps<Theme> = {
  flexDirection: 'column',
  display: 'flex',
  alignItems: 'center',
};

type ProficiencyLevelWidgetProps = Readonly<{
  currentProficiencyLevel: number;
}>;

export const ProficiencyLevelWidgetIcon = ({
  currentProficiencyLevel,
}: ProficiencyLevelWidgetProps): ReactElement => {
  switch (currentProficiencyLevel) {
    case 1:
      return <IconItem text={PROFICIENCY_STRINGS.advanced.title} iconName="ModuleLevelOne" />;
    case 2:
      return <IconItem text={PROFICIENCY_STRINGS.expert.title} iconName="ModuleLevelTwo" />;
    default:
      // if our proficiency is 0, or if we don't have a valid proficiency level, we default to the basic level
      return <IconItem text={PROFICIENCY_STRINGS.basic.title} iconName="ModuleUncompleted" />;
  }
};
